module.exports = __webpack_public_path__ + "media/bundles/CityInfo/woman_icon-8c16b056bcecc98464de06206b142016.svg";